export function formatinusd(price) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(price)
}

export async function ethToUsd(value) {
    let ethPrice;
    let tempEthPrice = sessionStorage.getItem("ethPrice");
    if (tempEthPrice != null) {
        ethPrice = tempEthPrice;
    } else {
        const result = await fetch("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD");
        const json = await result.json();
        ethPrice = json.USD;
        sessionStorage.setItem("ethPrice", ethPrice);
    }
    let usdprice = parseFloat(parseFloat(ethPrice * value).toFixed(2));
    return formatinusd(usdprice);
}


export async function usdToEth(value) {
    let ethPrice;
    let tempEthPrice = sessionStorage.getItem("ethPrice");
    if (tempEthPrice != null) {
        ethPrice = tempEthPrice;
    } else {
        const result = await fetch("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD");
        const json = await result.json();
        ethPrice = json.USD;
        sessionStorage.setItem("ethPrice", ethPrice);
    }
    let usdprice = calculateZeroes((1 / parseFloat(ethPrice)) * parseFloat(value));
    return usdprice;
}

export async function currentEthPrice() {
    let ethPrice;
    let tempEthPrice = sessionStorage.getItem("ethPrice");
    if (tempEthPrice != null) {
        ethPrice = tempEthPrice;
    } else {
        const result = await fetch("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD");
        const json = await result.json();
        ethPrice = json.USD;
        sessionStorage.setItem("ethPrice", ethPrice);
    }
    return ethPrice;
}

export function calculateZeroes(val) {
    val = parseFloat(val);
    let zeroes = getZeroes(val);
    if (zeroes == 0) {
        val = Math.ceil(val * 100) / 100;
    } else if (zeroes == 1) {
        val = Math.ceil(val * 1000) / 1000;
    } else if (zeroes == 2) {
        val = Math.ceil(val * 10000) / 10000;
    } else if (zeroes == 3) {
        val = Math.ceil(val * 100000) / 100000;
    }
    return (val).toLocaleString('fullwide', { useGrouping: false });
}

function getZeroes(val) {
    try {
        return val.toString().match(/(\.0*)/)[0].length - 1;
    } catch (e) {
        return 0
    }
}
